import { isFeatureEnabled } from 'h-commons';

export const NewMWApi = {
    JWT_FEATURE_KEY: 'rls-chat-v2-separation-m3',
    hasJwtEnabled: function (availableFeatures = [], flagType = NewMWApi.JWT_FEATURE_KEY) {
        return isFeatureEnabled(availableFeatures, flagType);
    },
    postCreateInbox: {  // api has been added
        v2: { url: '/gx/api/channels/inboxes' },
        middleWare: { url: 'v2/inboxes' },
        type: 'POST'
    },
    patchCreateInbox: { //api has been added
        v2: { url: '/gx/api/channels/inboxes/{{inbox-id}}' },
        middleWare: { url: 'v2/inboxes/{{inbox-id}}' },
        type: 'PATCH'
    },
    getChannelInboxes: {    //TBD: api is not added -> shared mailboxes are currently only available in v2
        v2: { url: '/gx/api/channels/inboxes' },
        middleWare: { url: 'v2/inboxes' },
        type: 'GET'
    },
    getSpecificChannelInbox: {  // api has been added
        v2: { url: '/gx/api/channels/inboxes/{{inbox-id}}' },
        middleWare: { url: 'v2/inboxes/{{inbox-id}}' },
        type: 'GET'
    },
    deleteSpecificChannelInbox: {   //api has been added
        v2: { url: '/gx/api/channels/inboxes/{{inbox-id}}' },
        middleWare: { url: 'v2/inboxes/{{inbox-id}}' },
        type: 'DELETE'
    },
    fetchAllKbArticles: {
        middleWare: { url: 'v2/knowledge-base/article' },
        type: 'GET'
    },
    toggleIceBreaker: {
        v2: { url: '/api/toggle_suggestions' },
        middleWare: { url: 'api/toggle_suggestions' },
        type: 'PATCH'
    }
}
